import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './app/App';
import { preloadPublicPage } from './app/publicPageRegistry';
import './index.css';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Prerendered public, service, and city pages ship HTML inside #root.
// The matching route chunk is preloaded in that HTML and awaited here so
// hydrateRoot's first render already has the page component (no Suspense
// fallback, no extra nodes). The cookie bar and app banner are part of that
// first render. An empty root (spa.html) renders on the client as before.
async function start() {
  if (container.hasChildNodes()) {
    try {
      await preloadPublicPage(window.location.pathname);
    } catch (err) {
      // Hydrate anyway. PublicPage suspends until the chunk resolves.
    }
    hydrateRoot(container, app);
    return;
  }
  createRoot(container).render(app);
}

start();


